export default __webpack_public_path__ + "static/media/omnione_getstarted_hero.43c95c1c.png";